import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayGridDate } from './utils';

export const MAXIMUM_KEYWORD_COUNT_UNDER_CAMPAIGN = '10000';

interface IGetKeywordUrlProps {
  customerId: string;
  accountId: string;
  campaignId: string;
  params?: {
    $top: string;
    $skip: string,
    $count: string;
    $select: string
    $orderby: string;
  };
}

const keywordOdataConfig = {
  $top: MAXIMUM_KEYWORD_COUNT_UNDER_CAMPAIGN,
  $skip: '0',
  $count: 'true',
  $orderby: 'DeliveryStatus asc',
  $expand: 'AdGroup($select=Id,Name,PricingModel),Campaign($select=BaseCampaignName,BidStrategyName,CampaignType,ExperimentId,Id,Name),Labels,RSAAdCustomizerAttributes',
  $select: 'Bid/Amount,BidBelowFirstPageDetail,BidEstimate,BidEstimate/BestPositionBidEstimation,BidEstimate/FirstPageBidEstimation,BidEstimate/MainlineBidEstimation,DeliveryStatus,DeliveryStatusDetails,DestinationUrl,DisplayBiddingStrategyType,FinalUrlSuffix,FinalUrls,Id,IsBidLandscapeAvailable,MatchType,MobileFinalUrls,NegativeKeywordConflictDetails,Param1,Param2,Param3,PerformanceMetrics/AbsoluteTopImpressionRate,PerformanceMetrics/AverageCPC,PerformanceMetrics/CTR,PerformanceMetrics/Clicks,PerformanceMetrics/ConversionsCredit,PerformanceMetrics/Impressions,PerformanceMetrics/PartialConversionCPA,PerformanceMetrics/Spend,PerformanceMetrics/TopImpressionRate,QualityScore,Status,Text,TrackingUrlTemplate,UrlCustomParameters',
};

export interface IFetchKeywordDataProps extends IGetKeywordUrlProps {
  ccToken: string;
}

export function getFetchKeywordUrl({
  customerId,
  accountId,
  campaignId,
  params = keywordOdataConfig,
}: IGetKeywordUrlProps) {
  const queryString = new URLSearchParams(params);

  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/Keywords/Default.GridData?${queryString}`;
}

export function fetchKeywordData({
  accountId,
  customerId,
  campaignId,
  ccToken,
}: IFetchKeywordDataProps) {
  const url = getFetchKeywordUrl({ customerId, accountId, campaignId });

  const postDataParams = {
    gridDataParameters: {
      DateRange: {
        StartDate: formatTodayGridDate(),
        EndDate: formatTodayGridDate(),
      },
      CurrentCustomerId: customerId,
    },
  };

  return axios.post(
    url,
    {
      ...postDataParams,
    },
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
      },

    } as AxiosRequestConfig,
  );
}
